<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  @if (tooltip) {
    <title>{{ tooltip }}</title>
  }
  <path
    d="M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"/>
</svg>
